import React from 'react';
import {Card, Col, Container, Image, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import ApiService from "../../api/ApiService";
import {toast} from "react-toastify";

export default function CourseInfo() {
    const {id} = useParams();
    const api = new ApiService();
    const navigate = useNavigate();
    const [agentInfo, setAgentInfo] = React.useState(null);
    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用

        api.getCourseInfo(id).then(res => {
            if (res.code === 200) {
                setAgentInfo(res.data);
            } else if (res.code === -4001) {
                toast.error('请先登录');
                navigate('/home');
            } else {
                toast.error(res.msg);
            }
        })
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const isImage = (url) => {
        if (!url) return false;
        const imageExtensions = ['\.jpg$', '\.jpeg$', '\.png$', '\.gif$'];
        const regex = new RegExp(imageExtensions.join('|'), 'i');
        return regex.test(url);
    };

    return (
        <>
            <Container>
                <div className={'pb-3'}>
                    <div style={{alignItems: 'start', display: 'flex',}}>
                        <button style={{
                            color: '#101217',
                            border: 'none',
                            background: '#02C8E3',
                            borderRadius: '12px',
                            padding: '6px 22px',
                        }} onClick={() => {
                            navigate(-1)
                        }}>
                        <span style={{marginRight: '10px'}}>
                        <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                      </span>
                            返回
                        </button>
                    </div>
                    <div style={{ padding: '24px 0px', borderRadius: '20px',}}>
                        <Row>
                            <Col lg={12}>
                                <Card style={{borderRadius: '20px', overflow: 'hidden', border: 'none'}}>
                                    <>
                                        {isImage(agentInfo?.videoContent) ? (
                                            <img style={{
                                                width: '100%',
                                                height: 'auto',
                                                maxHeight: '700px',
                                                background: '#000',
                                                objectFit: 'contain'
                                            }} src={agentInfo?.videoContent} alt=""/>
                                        ) : (
                                            <video autoPlay={true}
                                                   src={agentInfo?.videoContent}
                                                   style={{
                                                       width: '100%',
                                                       height: 'auto',
                                                       maxHeight: '700px',
                                                       background: '#000',
                                                       objectFit: 'contain'
                                                   }}
                                                   controls preload="metadata"
                                                   poster={agentInfo?.cover}/>
                                        )}
                                    </>

                                </Card>
                                <h5 style={{
                                    color: '#fff',
                                    marginTop: '20px',
                                    textAlign: 'left'
                                }}>{agentInfo?.title}</h5>
                                <p style={{
                                    color: '#697880',
                                    fontSize: '16px',
                                    textAlign: 'left'
                                }}>{agentInfo?.learningCount > 10000 ? (agentInfo?.learningCount / 10000).toFixed(2) + '万' : agentInfo?.learningCount}次学习</p>
                                {agentInfo?.user &&
                                    <p style={{color: '#697880', fontSize: '18px', textAlign: 'left'}}>
                                        <Image roundedCircle={true} width={'60px'} height={'60px'}
                                               style={{marginRight: '10px',background:'rgba(255,255,255,0.2)'}}
                                            src={agentInfo?.user?.avatar?agentInfo?.user?.avatar: '/images/logo.svg'}/>
                                        {agentInfo?.user?.nickname ? agentInfo?.user?.nickname : '沸推AI'}
                                    </p>
                                }

                            </Col>

                        </Row>
                    </div>
                </div>
            </Container>
        </>
    );
}
